import axios from 'axios';
import createDataProvider from './createDataProvider';
import onApiRequest from './ApiRequestHandler';
import { providerContextReducer } from './reducer';

const initialState = {
  teams: { value: [], loading: false, error: null },
  seasons: { value: [], loading: false, error: null },
  season: { value: null, loading: false, error: null }
};

const formatAssociationDomain = (domain) =>
  domain?.endsWith('/')
    ? domain.substring(0, domain.length - 1)
    : domain.trim();

const fetchAssociationTeams = (dispatch) => async (
  associationDomain,
  onSuccessCallback,
  onErrorCallback
) => {
  onApiRequest(
    {
      dispatch,
      stateName: 'teams',
      url: `/api/admin/teams/all`,
      type: 'get',
      resetStateValue: [],
      filter: { associationDomain },
      axiosInstance: axios.create({baseURL: formatAssociationDomain(associationDomain)})
    },
    onSuccessCallback,
    onErrorCallback
  );
};

const fetchAssociationSeasons = (dispatch) => async (
  associationDomain,
  onSuccessCallback,
  onErrorCallback
) => {
  onApiRequest(
    {
      dispatch,
      stateName: 'seasons',
      url: `/api/admin/seasons/list`,
      type: 'get',
      resetStateValue: [],
      filter: { associationDomain },
      axiosInstance: axios.create({baseURL: formatAssociationDomain(associationDomain)})
    },
    onSuccessCallback,
    onErrorCallback
  );
};

const fetchAssociationSeason = (dispatch) => async (
  associationDomain,
  pkSeason,
  onSuccessCallback,
  onErrorCallback
) => {
  onApiRequest(
    {
      dispatch,
      stateName: 'season',
      url: `/api/admin/teams/season/${pkSeason}`,
      type: 'get',
      resetStateValue: null,
      filter: { associationDomain, pkSeason },
      axiosInstance: axios.create({baseURL: formatAssociationDomain(associationDomain)})
    },
    onSuccessCallback,
    onErrorCallback
  );
};

export const { Provider, Context } = createDataProvider(
  providerContextReducer,
  {
    fetchAssociationTeams,
    fetchAssociationSeasons,
    fetchAssociationSeason
  },
  initialState
);
